export const blockIconsActionVisibility = (
	<span className='material-symbols-outlined'>visibility</span>
);
